export default {
  apiGateway: {
    REGION: "eu-west-1",
    URL: "https://fr0d428t3g.execute-api.eu-west-1.amazonaws.com/dev"
  }
};